"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var typography = {
  typographyColor: _color["default"].pickledBluewood800,
  typographyFontSize: _font["default"].sizeSm,
  typographyPaddingBottomParagraph: _spacing["default"].xs,
  typographyFontWeight: _font["default"].weightDefault
};
var _default = typography;
exports["default"] = _default;